import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioCuentasMedicasService {

  constructor( private requestUrl: ReportesRequestService ) { }

  async getParametroSimensDomicilio(cuentaMedicaDomicilio: CuentaMedicaDomicilioEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'parametro-simens/domicilio-sede',
        [
          cuentaMedicaDomicilio.codigo,
          {
            'sede' : cuentaMedicaDomicilio.sede
          }
        ]);
        return response;
    } catch(e) {
      console.error(`ServicioCuentasMedicasService.getParametroSimensDomicilio() : ${e}`);
    }
    return null;
  }

  async getProfesionalDomicilio( cuentaMedicaDomicilio: CuentaMedicaDomicilioEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'reporte-cuentas-medicas/profesional',
        [
          cuentaMedicaDomicilio.codigo,
          {
            'profesional' : cuentaMedicaDomicilio.uncoProfesional
          }
        ]);
        return response;
    } catch(e) {
      console.error(`ServicioCuentasMedicasService.getProfesionalDomicilio() : ${e}`);
    }
    return null;
  }

  async getAdmisionesDomicilio( cuentaMedicaDomicilio: CuentaMedicaDomicilioEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'reporte-cuentas-medicas/admisiones-by-rango',
        [
          cuentaMedicaDomicilio.codigo,
          {
            'profesionalRango' : cuentaMedicaDomicilio.uncoProfesionalRango
          }
        ]);
        return response;
    } catch(e) {
      console.error(`ServicioCuentasMedicasService.getAdmisionesDomicilio() : ${e}`);
    }
    return null;
  }
  
}

export interface ParametroSimensEntity {
  formularioAdmision ?: number;
  notaImpresionCuentaCobroDomiciliario ?: string;
  entidadEmpresarial ?: EntidadEmpresarialEntity;
}

export interface EntidadEmpresarialEntity {
  unco ?: number;
  descripcion ?: string;
  identificacionTributaria ?: string;
  digitoVerificacion ?: string;
  direccion ?: string;
  municipio ?: string;
  telefonoMovil ?: string;
  telefonoPbx ?: string;
  fax ?: string;
}

export interface CuentaMedicaDomicilioEntity {
  codigo ?: string;
  uncoProfesional ?: number;
  uncoProfesionalRango ?: number;
  sede ?: number;
  uncoLogin ?: number;
} 

export interface ProfesionalEntity {
  unco ?: number;
  nombres ?: string;
  apellidos ?: string;
  registroMedico ?: string;
  telefono ?: string;
  direccion ?: string;
  numeroIdentificacion ?: string;
  tipoDocumento ?: TipoDocumentoEntity;
  especialidades ?: ProfesionalEspecialidadEntity[];
}

interface TipoDocumentoEntity {
  unco ?: number;
  codigo ?: string;
  descripcion ?: string;
}

interface EspecialidadEntity {
  unco ?: number;
  descripcion ?: string;
}

export interface ProfesionalEspecialidadEntity {
  unco ?: number;
  especialidad ?: EspecialidadEntity;
}

export interface AdmisionServicioDetalleHonorariosEntity {
  cantidadRealizada ?: number;
  tarifaRealizada ?: number;
  admisionServicioDetalle ?: AdmisionServicioDetalleEntity;
}

interface AdmisionServicioDetalleEntity {
  admisionEmpresaPuntoAtencion ?: AdmisionEmpresaPuntoAtencionEntity;
}

interface AdmisionEmpresaPuntoAtencionEntity {
  admisionEmpresa ?: AdmisionEmpresaEntity;
}

interface AdmisionEmpresaEntity {
  admision?: AdmisionEntity;
  empresa ?: EmpresaEntity;
}

interface EmpresaEntity {
  descripcionCorta: string;
}

interface AdmisionEntity {
  afiliado ?: AfiliadoEntity;
  prefijo ?: string;
  consecutivo ?: number;
}

interface AfiliadoEntity {
  primerNombre ?: string;
  segundoNombre ?: string;
  primerApellido ?: string;
  segundoApellido ?: string;
  numeroIdentificacion ?: string;
  tipoDocumento ?: string;
}